import React, {lazy, Suspense} from "react";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {ManagePublicAccess, ManagePrivateAccess, ManageBothAccess} from "./ManageAccess";

import path from "./path";

import ScrollToTop from "./ ScrollToTop";
import CustomPageLoader from "../components/customPageLoader";

const LoginPage = lazy(() => import(/*webpackChunkName: "LoginPage" */ '../app/login/LoginPage'))
const SocialLoginIntermediaryPage = lazy(() => import(/*webpackChunkName: "SocialLoginIntermediaryPage" */ '../app/login/SocialLoginIntermediaryPage'))
const RegistrationPage = lazy(() => import(/*webpackChunkName: "RegistrationPage" */ '../app/registration/RegistrationPage'))
const ForgetPasswordPage = lazy(() => import(/*webpackChunkName: "ForgetPasswordPage" */ '../app/forget-password/ForgetPasswordPage'))
const ForgetPasswordPhonePage = lazy(() => import(/*webpackChunkName: "ForgetPasswordPhonePage" */ '../app/forget-password/ForgetPasswordPhonePage'))
const ForgetPasswordConfirmPage = lazy(() => import(/*webpackChunkName: "ForgetPasswordConfirmPage" */ '../app/forget-password/ForgetPasswordConfirmPage'))
const ForgotPasswordPhoneConfirmationPage = lazy(() => import(/*webpackChunkName: "ForgotPasswordPhoneConfirmationPage" */ '../app/forget-password/ForgotPasswordPhoneConfirmationPage'))
const PasswordResetPage = lazy(() => import(/*webpackChunkName: "PasswordResetPage" */ '../app/password-reset/PasswordResetPage'))
const RegistrationConfirmationPage = lazy(() => import(/*webpackChunkName: "RegistrationConfirmationPage" */ '../app/registration/RegistrationConfirmationPage'))
const RegistrationPhoneConfirmationPage = lazy(() => import(/*webpackChunkName: "RegistrationPhoneConfirmationPage" */ '../app/registration/RegistrationPhoneConfirmationPage'))
const RegistrationConfirmationSignupPage = lazy(() => import(/*webpackChunkName: "RegistrationConfirmationSignupPage" */ '../app/registration/RegistrationConfirmationSignupPage'))
const UnwantedCloseRegisterEmail = lazy(() => import(/*webpackChunkName: "UnwantedCloseRegisterEmail" */ '../app/registration/UnwantedCloseRegisterEmail'))
const UnwantedCloseRegisterPhone = lazy(() => import(/*webpackChunkName: "UnwantedCloseRegisterPhone" */ '../app/registration/UnwantedCloseRegisterPhone'))

const PublicProfileMentor = lazy(() => import(/*webpackChunkName: "PublicProfileMentor" */ '../app/public-profile/PublicProfileMentor'))
const MentorCourses = lazy(() => import(/*webpackChunkName: "MentorCourses" */ '../app/mentor-courses/MentorCourses'))
const NotificationSettings = lazy(() => import(/*webpackChunkName: "NotificationSettings" */ '../app/notification-settings/NotificationSettings'))
const InstructorDetails = lazy(() => import(/*webpackChunkName: "InstructorDetails" */ '../app/instructor-details/InstructorDetails'))
const Profile = lazy(() => import(/*webpackChunkName: "Profile" */ '../app/profile/Profile'))
const PurchaseHistory = lazy(() => import(/*webpackChunkName: "PurchaseHistory" */ '../app/order/PurchaseHistory'))
const OrderDetails = lazy(() => import(/*webpackChunkName: "OrderDetails" */ '../app/order/OrderDetails'))
const Home = lazy(() => import(/*webpackChunkName: "Home" */ '../app/home/Home'))

const CourseUpdate = lazy(() => import(/*webpackChunkName: "CourseUpdate" */ '../app/course-create/CourseUpdate'))
const CourseDetails = lazy(() => import(/*webpackChunkName: "CourseDetails" */ '../app/course-details/CourseDetails'))
const CourseDetailsNew = lazy(() => import(/*webpackChunkName: "CourseDetailsNew" */ '../app/course-details-new/CourseDetailsNew'))
const CourseDetailsTutorialDetails = lazy(() => import(/*webpackChunkName: "CourseDetailsTutorialDetails" */ '../app/course-details-tutorial-details/CourseDetailsTutorialDetails'))
const CourseCreate = lazy(() => import(/*webpackChunkName: "CourseCreate" */ '../app/course-create/CourseCreate'))
const AllCourse = lazy(() => import(/*webpackChunkName: "AllCourse" */ '../app/all-course/AllCourse'))
const MyCart = lazy(() => import(/*webpackChunkName: "MyCart" */ '../app/cart/MyCart'))

const Landing = lazy(() => import(/*webpackChunkName: "Landing" */ '../app/landing-page/landing'))
const CourseListpage = lazy(() => import(/*webpackChunkName: "CourseListpage" */ '../app/course-list-page/CourseListPage'))
// const CourseListpage = lazy(() => pMinDelay(import(/*webpackChunkName: "CourseListpage" */ '../app/course-list-page/CourseListPage')), 500)
const Career = lazy(() => import(/*webpackChunkName: "Career" */ '../app/footer-static-content-pages/career/Career'))
const OurStrength = lazy(() => import(/*webpackChunkName: "OurStrength" */ '../app/footer-static-content-pages/our-strength/OurStrength'))
const TermsService = lazy(() => import(/*webpackChunkName: "TermsService" */ '../app/footer-static-content-pages/terms-services/TermsService'))
const RefundPolicy = lazy(() => import(/*webpackChunkName: "RefundPolicy" */ '../app/footer-static-content-pages/refunc-policy/RefundPolicy'))
const PrivacyPolicy = lazy(() => import(/*webpackChunkName: "PrivacyPolicy" */ '../app/footer-static-content-pages/privacy-policy/PrivacyPolicy'))
const FAQ = lazy(() => import(/*webpackChunkName: "FAQ" */ '../app/footer-static-content-pages/FAQ/FAQ'))
const AboutUs = lazy(() => import(/*webpackChunkName: "AboutUs" */ '../app/footer-static-content-pages/about-us/AboutUs'))
const ContactUs = lazy(() => import(/*webpackChunkName: "ContactUs" */ '../app/footer-static-content-pages/contact-us/ContactUs'))


const Error404 = lazy(() => import(/*webpackChunkName: "Error404" */ '../app/error-pages/404'))

const routes = [
    // registration
    {
        accessRequired: 'no',
        path: path.registration,
        component: RegistrationPage,
    },
    {
        accessRequired: 'no',
        path: path.registration_phone,
        component: RegistrationPage,
    },
    {
        accessRequired: 'no',
        path: path.registration_verify_email,
        component: UnwantedCloseRegisterEmail
    },
    {
        accessRequired: 'no',
        path: path.registration_verify_phone,
        component: UnwantedCloseRegisterPhone
    },

    {
        accessRequired: 'no',
        path: path.registration_confirmation,
        component: RegistrationConfirmationPage,
    },
    {
        accessRequired: 'no',
        path: path.confirm_signup,
        component: RegistrationConfirmationSignupPage
    },
    {
        accessRequired: 'yes',
        path: "/signin",
        component: RegistrationConfirmationSignupPage
    },
    {
        accessRequired: 'no',
        path: path.registration_phone_confirmation,
        component: RegistrationPhoneConfirmationPage,
    },

    // Forgot Password
    {
        accessRequired: 'no',
        path: path.forgot_password,
        component: ForgetPasswordPage,
    },
    {
        accessRequired: 'no',
        path: path.forgot_password_phone,
        component: ForgetPasswordPhonePage,
    },

    {
        accessRequired: 'no',
        path: path.forgot_password_confirm,
        component: ForgetPasswordConfirmPage,
    },

    {
        accessRequired: 'no',
        path: path.forgot_password_phone_confirm,
        component: ForgotPasswordPhoneConfirmationPage,
    },

    // Reset Password
    {
        accessRequired: 'no',
        path: path.reset_password,
        component: PasswordResetPage,
    },
    {
        accessRequired: 'no',
        path: path.reset_password_phone,
        component: PasswordResetPage,
    },


    // login
    {
        accessRequired: 'no',
        path: path.login,
        component: LoginPage,
    },

    // Social Login
    {
        accessRequired: 'no',
        path: path.social_redirect_url,
        component: SocialLoginIntermediaryPage,
    },


    // Landing Page
    {
        accessRequired: 'both',
        path: path.home,
        exact: true,
        component: Landing,
    },

    // Course List Page
    {
        accessRequired: 'both',
        path: path.course_list,
        exact: true,
        component: CourseListpage
    },

    // Dashboard
    {
        accessRequired: 'yes',
        path: path.dashboard,
        component: Home,
    },

    // View Public Profile
    {
        accessRequired: 'yes',
        path: path.mentor_public_profile,
        component: PublicProfileMentor,
    },

    // My Courses
    {
        accessRequired: 'yes',
        path: path.mentor_courses,
        component: MentorCourses,
    },

    // all Courses
    {
        accessRequired: 'yes',
        path: path.all_course,
        exact: true,
        component: AllCourse,
    },

    // Profile
    {
        accessRequired: 'yes',
        path: path.profile,
        component: Profile,
    },

    // Order Details
    {
        accessRequired: 'yes',
        path: path.purchase_history,
        component: PurchaseHistory,
    },
    {
        accessRequired: 'yes',
        path: path.order_details,
        component: OrderDetails,
    },

    // Payment Method

    // Privacy

    // Notification Settings
    {
        accessRequired: 'yes',
        path: path.notification_settings,
        component: NotificationSettings,
    },

    // Close Account


    // Course Create
    {
        accessRequired: 'yes',
        path: path.course_create,
        component: CourseCreate,
    },

    // Course Update
    {
        accessRequired: 'yes',
        path: path.course_update,
        component: CourseUpdate,
    },


    // My Cart
    {
        accessRequired: 'yes',
        path: path.my_cart,
        exact: true,
        component: MyCart,
    },


    // Course Details
    {
        accessRequired: 'both',
        path: path.course_details,
        component: CourseDetails,
    },

    {
        accessRequired: 'both',
        path: path.course_details_new,
        component: CourseDetailsNew,
    },

    //Course Enroll
    {
        accessRequired: 'yes',
        path: path.course_enroll,
        component: CourseDetailsTutorialDetails,
    },


    // Instructor Details
    {
        accessRequired: 'both',
        path: path.instructor_details,
        component: InstructorDetails,
    },

    // Career

    {
        accessRequired: 'both',
        path: path.career,
        component: Career
    },

    // Our Strength
    {
        accessRequired: 'both',
        path: path.our_strength,
        component: OurStrength
    },

    // Terms of policy
    {
        accessRequired: 'both',
        path: path.terms_services,
        component: TermsService
    },

    // Refund Policy
    {
        accessRequired: 'both',
        path: path.refunc_policy,
        component: RefundPolicy
    },

    // Privacy Policy
    {
        accessRequired: 'both',
        path: path.privacy_policy,
        component: PrivacyPolicy
    },

    // FAQ
    {
        accessRequired: 'both',
        path: path.site_faq,
        component: FAQ
    },

    // About Us
    {
        accessRequired: 'both',
        path: path.about_us,
        component: AboutUs
    },

    // Contact Us
    {
        accessRequired: 'both',
        path: path.contact_us,
        component: ContactUs
    },


    //   {
    //     path: "/tacos",
    //     component: Tacos,
    //     routes: [
    //       {
    //         path: "/tacos/bus",
    //         component: Bus
    //       },
    //       {
    //         path: "/tacos/cart",
    //         component: Cart
    //       }
    //     ]
    //   }
];

export const MainRoutes = () => {
    return (
        <Router>
            <ScrollToTop>
                <Suspense fallback={<CustomPageLoader background pageLoader={true}/>}>
                    <Switch>
                        {routes.map((route, i) =>
                            (route.accessRequired === 'yes') ? (
                                <ManagePrivateAccess
                                    key={i}
                                    path={route.path}
                                    accessRequired={route.accessRequired}
                                    exact
                                    component={route.component}
                                />
                            ) : (route.accessRequired === 'no') ? (
                                <ManagePublicAccess
                                    key={i}
                                    exact
                                    path={route.path}
                                    component={route.component}
                                />
                            ) : (
                                <ManageBothAccess
                                    key={i}
                                    exact
                                    path={route.path}
                                    component={route.component}
                                />
                            )
                        )}
                        <Route component={Error404}/>
                    </Switch>
                </Suspense>
            </ScrollToTop>
        </Router>
    );
};

const RouteWithSubRoutes = (route, index) => {
    return (
        <Route
            key={index}
            path={route.path}
            exact={route.exact}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes}/>
            )}
        />
    );
};

